/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row, Space } from 'antd'
import { formatDateWithoutTime, numberWithComma } from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { getGrnHistoryAPI } from 'Store/stock/api'
import { GrnHistoryData, GrnHistoryListReq, StockListData } from 'Store/stock/types'
import { selectGrnHistoryList, selectGrnHistoryListEvent } from 'Store/stock/selector'
import { TableListPage } from 'Components/common/Table'
import GrnDetail from '../GRN/detail'
import ProductUomSystemInfo from 'Pages/Product/components/ProductUomSystemInfo'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  data?: StockListData
}

const GrnHistory: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, currentUser, event, detail, data } = props
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)

  const dispatch = useDispatch()

  const onGetDetail = (): void => {
    const req: GrnHistoryListReq = {
      product_id: data?.product_id || 0,
      product_option_id: data?.product_option_id || 0,
    }
    dispatch(getGrnHistoryAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (visible) {
      onGetDetail()
    }
  }, [data, visible])

  const renderProductName = (data?: StockListData) => {
    const isSameTitle = data?.product_title == data?.product_option_title
    return (
      <>
        {data?.product_title}
        {!isSameTitle && ` (${data?.product_option_title})`}
      </>
    )
  }

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const onClickViewDetail = (id: number) => {
    setSelectedID(id)
    onOpenDetailDrawer()
  }

  const GrnDetailDrawer = (
    <GrnDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={() => {}}
      viewMode={true}
    />
  )

  const title = renderProductName(data)

  const renderQuantity = (quantity: number, record: GrnHistoryData) => {
    const uom = (
      <ProductUomSystemInfo
        multiplier={record.multiplier}
        quantity={record.received_amount}
        uom={record.product_uom || ''}
        quantitySystem={(record.received_amount || 0) * (record.multiplier || 1)}
        uomSystem={record.product_uom_system || ''}
        showQuantity={true}
      />
    )
    return (
      <Space>
        {numberWithComma(quantity)}
        {uom}
      </Space>
    )
  }

  const columns = [
    // {
    //   title: 'ลำดับ',
    //   dataIndex: 'no',
    //   key: 'no',
    //   render: (value: any, record: any, index: number) => {
    //     return index + 1
    //   },
    //   width: '60px',
    // },
    {
      title: 'เลขที่ใบสั่งซื้อ',
      dataIndex: 'purchasing_no',
      key: 'purchasing_no',
      width: '180px',
    },
    {
      title: 'เลขที่ใบจ่ายหนี้',
      dataIndex: 'grn_no',
      key: 'grn_no',
      width: '180px',
      render: (val: string, record: GrnHistoryData) => (
        <GrnNo onClick={() => onClickViewDetail(record?.grn_id)}>{val}</GrnNo>
      ),
    },
    {
      title: 'วันที่สั่งซื้อ',
      dataIndex: 'purchasing_date',
      key: 'purchasing_date',
      render: (val: string) => {
        return formatDateWithoutTime(val || '')
      },
    },
    {
      title: 'วันที่รับเข้าคลัง',
      dataIndex: 'received_date',
      key: 'received_date',
      render: (value: any) => {
        return formatDateWithoutTime(value)
      },
    },
    {
      title: 'ราคาซื้อ',
      dataIndex: 'price_per_unit',
      key: 'price_per_unit',
      render: (value: any) => {
        return numberWithComma(value, true)
      },
    },
    {
      title: 'ต้นทุนเฉลี่ย',
      dataIndex: 'average_cost',
      key: 'average_cost',
      render: (value: any) => {
        return numberWithComma(value, true)
      },
    },
    {
      title: 'จำนวน',
      dataIndex: 'received_amount',
      key: 'received_amount',
      render: renderQuantity,
      // render: (value: any) => {
      //   return numberWithComma(value)
      // },
    },
    // {
    //   title: 'จำนวนรับเข้า',
    //   dataIndex: 'total_original_recieved_amount',
    //   key: 'total_original_recieved_amount',
    //   render: (value: any) => {
    //     return numberWithComma(value)
    //   },
    // },
    // {
    //   title: 'จำนวนลดหนี้',
    //   dataIndex: 'total_original_recieved_amount',
    //   key: 'total_original_recieved_amount',
    //   render: (value: any, record: GrnHistoryData) => {
    //     return numberWithComma(value - (record?.total_recieved_amount || 0))
    //   },
    // },
    {
      title: 'ผู้สร้างรายการ',
      dataIndex: 'username',
      key: 'username',
    },
  ]

  return (
    <DetailDrawer title={title} onCloseDrawer={onCloseDrawer} visible={visible} footer={null} width={'80%'}>
      <Row justify="space-between" gutter={16}>
        <Col>
          <Title>ข้อมูลรายการรับเข้า</Title>
        </Col>
        <Col span={24}>
          <TableListPage
            columns={columns}
            datas={detail}
            isLoading={event.IsLoading}
            paginationContent={null}
            size="small"
            rowKey="product_option_id"
          />
        </Col>
      </Row>
      {GrnDetailDrawer}
    </DetailDrawer>
  )
}

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const GrnNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectGrnHistoryListEvent(state),
    detail: selectGrnHistoryList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(GrnHistory)
